export default __webpack_public_path__ + "static/media/contract_approval.6e38c03c.png";